import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Spinner from "../../components/helpers/Spinner";
import ResponsiveModalAbsolute from "../../components/ResponsiveModalAbsolute";

import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";

import { useDispatchDominio } from "../../hooks/useDispatchDominio";
import { set } from "date-fns";

interface Props {
    modalVisible: boolean;
    setModalVisible: (s: boolean) => void;

    id_tour: number;
}

export interface Nombre {
    nombre: string;
    descripcion: string;
}

export const ModalEditHorarioTour = ({
    modalVisible,
    setModalVisible,

    id_tour,
}: Props) => {
    const dispatchDominio = useDispatchDominio();
    const [saving, setSaving] = useState<boolean>(false);

    const [newHorario, setNewHorario] = useState({
        hora_inicio: "",
        hora_final: "",
    });
    const [horarios, setHorarios] = useState<
        { hora_inicio: string; hora_final: string }[]
    >([]);

    const getHorarios = async () => {
        try {
            const res = await fetchAxiosToken({
                url: `/hoteles_tours_horarios/getAll/${id_tour}`,
            });
            setHorarios(res);
        } catch (err) {
            console.log("Error obteniendo horarios", err);
            Swal.fire({
                title: "Error obteniendo horarios",
                icon: "error",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        }
    };

    const handleAddHorario = async () => {
        if (!newHorario.hora_inicio || !newHorario.hora_final) return;
        setSaving(true);
        try {
            await fetchAxiosToken({
                url: `/hoteles_tours_horarios/`,
                method: "post",
                body: {
                    id_hotel_tours: Number(id_tour),
                    ...newHorario,
                },
            });
            setNewHorario({ hora_inicio: "", hora_final: "" });
            getHorarios();
            setSaving(false);
        } catch (err: any) {
            console.error("Error agregando horario", err);
            Swal.fire({
                title: "Error agregando horario",
                text: `${err.response.data.error}`,

                icon: "error",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
            setSaving(false);
        }
    };

    const desactivarHorario = async (idHorario: number) => {
        if (horarios.length === 1) {
            return Swal.fire({
                title: "Error",
                text: "Debes tener al menos un horario activo",
                icon: "error",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        }

        try {
            await fetchAxiosToken({
                url: `/hoteles_tours_horarios/updateHabilitado/${idHorario}`,
                method: "put",
            });
            getHorarios();
        } catch (err) {
            console.error("Error desactivando horario", err);
        }
    };

    useEffect(() => {
        getHorarios();
    }, [modalVisible]);

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}>
            <div className="flex flex-col items-center justify-center max-w-lg gap-4 p-4 mx-auto ">
                <h2 className="2xl:text-4xl text-3xl text-[#1C4CBB] text-center font-medium">
                    Editar horarios
                </h2>
                <hr className="w-full bg-gray-300" />

                <div className="flex flex-col items-center justify-center w-11/12 mx-auto mt-4 ">
                    <h2 className="text-lg font-medium lg:text-xl 2xl:text-2xl">
                        Nuevo horario
                    </h2>
                    <div className="2xl:mt-10 lg:mt-5 mt-3 w-full flex flex-col md:w-1/2 gap-4 max-w-[468px] ">
                        <div className="flex gap-4">
                            <input
                                type="time"
                                value={newHorario.hora_inicio}
                                onChange={(e) =>
                                    setNewHorario({
                                        ...newHorario,
                                        hora_inicio: e.target.value,
                                    })
                                }
                                className="w-full p-2 border rounded-lg"
                            />
                            <input
                                type="time"
                                value={newHorario.hora_final}
                                onChange={(e) =>
                                    setNewHorario({
                                        ...newHorario,
                                        hora_final: e.target.value,
                                    })
                                }
                                className="w-full p-2 border rounded-lg"
                            />
                        </div>
                        <button
                            disabled={saving}
                            onClick={handleAddHorario}
                            className="p-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed">
                            Agregar horario
                        </button>
                        {horarios.length === 0 && (
                            <p className="text-sm font-medium text-red-500">
                                Necesitas agregar al menos un horario para
                                continuar.
                            </p>
                        )}
                        <div className="w-full mt-4">
                            <h3 className="font-medium">Horarios actuales:</h3>
                            <ul className="mt-2 space-y-1 text-sm">
                                {horarios.map((h: any, idx) => (
                                    <li
                                        key={idx}
                                        className="flex items-center justify-between px-3 py-2 border rounded-lg bg-gray-50">
                                        <span>
                                            {/* que no se muestren los segundos */}
                                            ⏰{h.hora_inicio.slice(0, 5)} -{" "}
                                            {h.hora_final.slice(0, 5)}
                                        </span>
                                        <button
                                            onClick={() =>
                                                desactivarHorario(h.id)
                                            }
                                            className="text-lg font-bold text-red-500 hover:text-red-700"
                                            title="Eliminar horario">
                                            ✖
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* <div className="w-10/12 2xl:mt-8 ">
                    {saving ? (
                        <Spinner />
                    ) : (
                        <button
                            onClick={() => handleSubmit()}
                            className="w-full p-3 px-5 text-white rounded-lg bg-[#1C4CBB] hover:scale-105 2xl:text-base text-sm">
                            Guardar cambios
                        </button>
                    )}
                </div> */}
            </div>
        </ResponsiveModalAbsolute>
    );
};
